import React from "react";
import "./Storie.scss";

const Storie = (props) => {
  return (
    <div className="storie">
      <img alt={props.alt} className="storie-img" src={props.url} />
      <span className="storie-name">{props.name}</span>
    </div>
  );
};

export default Storie;
